import { DataTableHeader } from "vuetify";

export const rateChangeHeaders: DataTableHeader[] = [
  {
    text: "Location Code",
    value: "locationCode"
  },
  {
    text: "Unit Type",
    value: "unitTypeName"
  },
  {
    text: "Area",
    value: "area"
  },
  {
    text: "Days Same",
    value: "daysSame"
  },
  {
    text: "Occupancy %",
    value: "occupancyPct"
  },
  {
    text: "Standard Rate",
    value: "stdRate"
  },
  {
    text: "Tenant Rate",
    value: "rent"
  },
  {
    text: "TR/SR Variance $",
    value: "var"
  },
  {
    text: "Formula",
    value: "formula_color"
  },
  {
    text: "Value Applied",
    value: "valueApplied"
  },
  {
    text: "Scheduled Rate",
    value: "newRent"
  },
  {
    text: "ScR/SR Var $",
    value: "newRentVar"
  },
  {
    text: "Status",
    value: "status"
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    width: "6.5rem"
  }
];
